import { mapActions, mapGetters } from 'vuex'
var timeTable = {
    data: () => ({
        timetable: [],
        format: 'HH:mm',
        wait: 20,
        tomorrow: 0,
        isClosed: false,
        roundMinutes: 5
    }),
    computed: {
        ...mapGetters( ['now']),
        toDay(){
           let today = this.$moment(this.now)
           if (today.hours() < 5) this.tomorrow = -1
           if (this.tomorrow) today.add(this.tomorrow, 'days')
           return today.format('dddd')
        },
        todayProp(){
            //console.log('getTimeTable',this.getTimeTable())
            //return {start: '9:30', end: "03:30"}
            return this.timetable.filter(t=>t.day==this.toDay)[0] || {}
        },
        tomorrowProp(){
            //console.log('getTimeTable',this.getTimeTable())
            //return {start: '9:30', end: "03:30"}
            return this.timetable.filter(t=>t.day==this.$moment(this.now).add(1, 'days').format('dddd'))[0] || {}
        },
        startDate(){
            let sDate =this.$moment(this.todayProp.start,this.format)
            if (this.tomorrow) sDate.add(this.tomorrow, 'days')
            return sDate
        },
        lastDate(){
            let eDate = this.$moment(this.todayProp.end,this.format).add(this.wait, 'minutes')
            if (this.tomorrow) eDate.add(this.tomorrow, 'days')
            if (eDate.isBefore(this.startDate)) eDate.add(1, 'days')
            return eDate
        },
        endDate(){
            let eDate = this.$moment(this.todayProp.end,this.format)
            if (this.tomorrow) eDate.add(this.tomorrow, 'days')
            if (eDate.isBefore(this.startDate)) eDate.add(1, 'days')
            return eDate
        },
        firstDate(){
             let date = this.roundDate(this.$moment(this.now).add(this.wait, 'minutes'))
            if (this.isOpenDate(date)) return this.roundDate(date)
            if (date.isBefore(this.startDate)) return this.startDate
            return null//.add(this.wait, 'minutes')
        },
        allowOrder(){
            if (this.isHost) return true //|| process.env.NUXT_ENV == 'dev'
            if (this.closed == true || this.isClosed == true || (this.host && this.host.closed== true)) return false
            //if (!this.firstDate) return false
            //console.log(this.host.name, this.firstDate, this.isOpen)
            return this.firstDate || this.isOpen ? true : false
        },
        isOpen(){
            if (this.closed == true || this.isClosed == true || (this.host && this.host.closed== true)) return false
            return this.isOpenDate()
        },
        opendata (){
            if (!this.todayProp) return {text: 'Geen openingstijden bekend', open: false, allow: false}
            if (this.isRoot && (this.closed || this.isClosed == true)) return {text: this.todayProp.description || `Gesloten`, open: false, allow: false}
            if ((this.closed || this.isClosed == true)) return {text: this.todayProp.description || `Gesloten voor vandaag`, open: false, allow: false}
            //if (this.todayProp.description && !this.isRoot) return {text: this.todayProp.description}
            if (this.isStoreOpenDate()) {
                return {text:`Open`, description:  `Vandaag geopend tot ${this.todayProp.end}`, open: true, allow: true}
            }else if ((this.isClosed || this.$moment().isAfter(this.lastDate) > 0) && (!this.tomorrowProp || !this.tomorrowProp.start)) {
                return {text: `Gesloten voor vandaag`, open: false, allow: false}
            }else if (this.isClosed) {
                return {text: `Gesloten`, description: `Morgen geopend vanaf ${this.tomorrowProp.start} tot ${this.tomorrowProp.end}`, open: false, allow: false}
            } else if  (this.$moment().isAfter(this.lastDate) == true){
                return {text: `Gesloten`, description: `Morgen geopend vanaf ${this.tomorrowProp.start} tot ${this.tomorrowProp.end}`, open: false, allow: false}
            }else{
                return {text: `Gesloten`, description: `Geopend vanaf ${this.todayProp.start} tot ${this.todayProp.end}`, open: false, allow: true}
            }
        },
        opentext(){
            let text = '<b>' + this.opendata.text + '</b>'
            if(this.opendata.description) text+= ', ' + this.opendata.description
            return text
        }
    },
    mounted () {
        //if (this.lastDate.isBefore(this.$moment(this.now))) this.tomorrow = 1
        if (this.host) this.setTimeTable(this.host)
        this.startTimer()
    },
    watch:{
        now(value){
            
        },
        deliver(value){
            if (!this.host) return false
            this.wait = 20
            if (!value && this.host.order && this.host.order.wait) this.wait = this.host.order.wait
            if (value && this.host.delivery && this.host.delivery.wait) this.wait = this.host.delivery.wait
        }
    },
    methods: {
        ...mapActions(['startTimer']),
        roundDate(start){
            const remainder = this.roundMinutes - (start.minute() % this.roundMinutes);
            return this.$moment(start).add(remainder, "minutes").startOf('minute')
            //
        },
        setTimeTable(host){
            this.isClosed = (host.closed == true)
            this.timetable=[...(host.timetable ||[])] || []
            this.wait = 20
            if (!this.deliver && host.order && host.order.wait) this.wait = host.order.wait
            if (this.deliver && host.delivery && host.delivery.wait) this.wait = host.delivery.wait
            this.$moment.weekdays(true).map((w,i)=>{
                if (this.timetable.filter(t=>t.day==w).length==0) this.timetable.push({
                    value: i, day: w, text: w.capitalize(),description: 'Geen openingstijden bekend'
                })
            })
            this.timetable.sort(aSort)
        },
        allowOrderDate(date){
            if (!date) date = new Date()
            let $date = this.$moment(date)
           if ($date.isBefore(this.firstDate)) return false
            return this.isOpenDate(date)
        },
        isOpenDate (date){
           if (!date) date = this.$moment(new Date())
           return this.$moment(date).isBetween(this.startDate, this.lastDate, null, '[]')
       },
       isStoreOpenDate (date){
        if (!date) date = this.$moment(new Date())
        return this.$moment(date).isBetween(this.startDate, this.endDate, null, '[]')
    },
       isOpenTime (time){
        return this.isOpenDate(this.$moment(time, this.format))
       },
       getFullTimeTable(div){
        if (!this.allowOrder || !this.firstDate) return []
        if (!div) div = 15
        let current = this.$moment(this.firstDate.toDate()).startOf('hour')
        let start = parseInt(current.format('HH'))
       let end = parseInt(this.$moment(this.lastDate).endOf('hour').format('HH'))
       
       if (end<start) end += 24
       let arr=[]
        for (let h = start;h<=end;h++){
            let slots = []
            for (let m = 0;m<60;m+=div){
                slots.push({
                    time: current.format('HH:mm'), 
                    date: (this.allowOrderDate(current)) ? current.toDate() : null
                })
                current.add(div,'minutes')
            }
            //current.add(1,'hours')
            arr.push({h, slots})
                //arr.push({hour: hour, slots: tt.filter(t=>t.time.split(':')[0]==hour)})
        }
       return arr
        },
       getTimeTable(div){
        if (!div) div = 15
        let table= []
        if (!this.allowOrder) return table
        let current = this.firstDate.toDate()
        while(this.isOpenDate(current)){
            table.push({time: this.$moment(current).format('HH:mm'),  date:this.$moment(current).toDate()})
            current = this.$moment(current).add(div, "minutes")
        }
        let last = {time: this.$moment(this.lastDate).format('HH:mm'),  date:this.$moment(this.lastDate).toDate()}
        if (table.filter(d=>d.time == last.time).length==0) table.push(last)
        return table
       }
    }
    
  }
 
  export default timeTable
  function zeroPad(num, places) {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }
  function aSort(a, b) {
    let dA = a.value
    let dB = b.value
    
    if (dA < dB) return -1;
    if (dB < dA) return 1;
  
    return 0;
  }